
import useSquad from "../../../Provider/useSquad";
import { Styles } from "../../Squad";

export const Leave = () => {

	const { Actions, instanceId } = useSquad();

	const handles = {
		leaveInstance: () => {
			Actions.instance.leave();
		},
	};

	return <Styles.Panel>
		<Styles.Title>Aktive Instanz</Styles.Title>

		<Styles.CurrentInstance>
			UUID: { instanceId }
		</Styles.CurrentInstance>

		<Styles.Button
			type="button"
			onClick={ handles.leaveInstance }
		>
			Instanz verlassen
		</Styles.Button>
	</Styles.Panel>
}